import { stringSearch } from '@luminovo/design-system';
import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { PageQuoteImporterExcel } from '@/areas/quote-requests/QuoteRequests/ExcelImporter/PageQuoteImporterExcel';
import { sourcingEditModulePermissions } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/negotiations/$negotiationId/_sidebar/quote-requests/importer')({
    staticData: {
        access: { permissions: ['view:sourcing'], modulePermissions: sourcingEditModulePermissions },
        chrome: 'home',
    } satisfies PageStaticData,
    validateSearch: stringSearch({ quoteRequestId: 'optional' }),
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    const quoteRequestId = Route.useSearch({ select: (search) => search.quoteRequestId });
    return <PageQuoteImporterExcel {...pathParams} projectId={undefined} quoteRequestId={quoteRequestId} />;
}
